module.exports = __webpack_public_path__ + "img/Frame-31.d60afd0f.svg";